import { queryOptions } from "@tanstack/react-query";

import type { ParticipantType } from "@/types/participant";

type Participant = Omit<ParticipantType, "id">;

export function createParticipantLoaderOptions() {
  return queryOptions<Participant>({
    queryKey: ["participant"],
    queryFn: async () => {
      return await fetch("/api/participant").then((res) => res.json());
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
  });
}
